import React from 'react';
import { format, formatDistanceToNow } from 'date-fns';
import { toZonedTime, format as formatWithTZ } from 'date-fns-tz';

const TimeCell = ({ timestamp, timezone = 'UTC', fontSize = 12, textAlign = 'left' }) => {
    let date;

    // Parse the timestamp based on its type
    if (typeof timestamp === 'string') {
        // Convert ISO string to a Date object
        date = new Date(timestamp);
    } else if (typeof timestamp === 'number') {
        // If the timestamp is a Unix timestamp (seconds), convert it to milliseconds
        date = new Date(timestamp * 1000);
    } else {
        // Invalid timestamp
        date = null;
    }

    // Check if the date is valid
    const isValidDate = date && !isNaN(date.getTime());

    let formattedDate, datePart, timePart, relativeTime;

    if (isValidDate) {
        // Convert to the specified timezone
        const zonedDate = toZonedTime(date, timezone);

        // Format the date with timezone support
        formattedDate = formatWithTZ(zonedDate, 'M/d/yyyy, h:mm a', { timeZone: timezone });

        // Split formatted date into date and time parts
        [datePart, timePart] = formattedDate.split(', ');

        // Compute relative time (local timezone for relative calculation)
        relativeTime = formatDistanceToNow(date, { addSuffix: true });
    } else {
        // Fallback for invalid dates
        datePart = '--';
        timePart = '';
        relativeTime = '';
    }

    return (
        <div style={{ textAlign }}>
            <div
                style={{
                    fontSize,
                    fontFamily: 'var(--font-title)',
                    fontWeight: '400',
                    color: isValidDate ? 'inherit' : 'red',
                }}
            >
                {datePart} {timePart}
            </div>
            {isValidDate && (
                <div style={{ fontSize, fontFamily: 'var(--font-title)' }}>
                    {`(${relativeTime})`}
                </div>
            )}
        </div>
    );
};

export default TimeCell;
